import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import styles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"
import globalStyles from "../../../Styles/global.module.scss"

// MUI
import Grid from '@mui/material/Grid2';
import { Avatar, Box, Chip, FormControlLabel, IconButton, styled, Switch, Tooltip, Typography } from '@mui/material';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';

import agent from '../../../Services/api';
import moment from 'moment';

// GLOBAL
import GlobalWarningDialog from '../../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';
import GlobalDialog from '../../../Utils/Layout/GlobalDialog/GlobalDialog';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';
import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';

import { UpdateUserStatusByPayloadModel } from '../../../models/memberAxiosModels';
import deleteIcon from "../../../Assets/Member/Delete-Icons.svg"
import { useIsBelow900 } from '../../../Utils/Constant/Constant';
import GlobalSelect from '../../../Utils/Layout/GlobalSelect/GlobalSelect';


const IOSSwitch = styled((props: any) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 40,
    height: 22,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 19,
        height: 18,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));

const Users = () => {

    const {
        memberUserListDetails,
        setMemberUserListDetails,
        setStoredExistingMemberDetails,
        storedExistingMemberDetails
    } = useContext(MemberContext) as MemberContextPayload

    const { setFlagLoader } = useContext(GlobalUserContext) as GlobalUserContextPayload
    const { showSnackbar } = useSnackbar();
    const isBelow900 = useIsBelow900();


    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [flagDeleteMemberDialog, setFlagDeleteMemberDialog] = useState(false)
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 20 });
    const [sortModel, setSortModel] = useState<any[]>([{ field: "", sort: "asc" }]);
    const [filterModel, setFilterModel] = useState<any>({});
    const [rowCount, setRowCount] = useState(0);
    const [groupOptionsList, setGroupOptionList] = useState<any>()
    const [storedUserId, setStoredUserId] = useState()


    const columns: any = [
        {
            field: 'profileImage',
            headerName: '',
            flex: 1,
            width: 80,
            minWidth: 80,
            maxWidth: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const image = params?.row?.profileImage
                const fullName = params?.row?.fullName
                return (
                    <>
                        <Avatar
                            src={image}
                            alt={fullName}
                        />
                    </>
                )
            }
        },
        {
            field: 'email',
            headerName: 'EMAIL',
            flex: 1,
            width: 350,
            minWidth: 350,
            // maxWidth: 400,
            getCellClassName: (params: any) => styles.fullNameStyles,
            renderCell: (params: any) => {
                const isAdmin = params.row.admin;
                const email = `${params.row?.email}`.trim();
                return (
                    <>
                        <Grid>
                            <Grid container sx={{ alignItems: "center" }}>
                                <Grid>
                                    {email}
                                </Grid>
                                {isAdmin && (
                                    <Grid>
                                        <Chip
                                            label="Admin"
                                            size="small"
                                            color="primary"
                                            sx={{ fontSize: '10px', height: '20px', ml: 1 }}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>

                    </>
                )
            }
        },
        {
            field: 'firstName',
            headerName: 'FULL NAME',
            flex: 1,
            width: 170,
            minWidth: 170,
            // maxWidth: 250,
            valueGetter: (params: any) => {
                const capitalize = (str: string) =>
                    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

                const firstName = capitalize(params.row?.firstName || "");
                const lastName = capitalize(params.row?.lastName || "");

                return `${firstName} ${lastName}`.trim();
            }
        },
        {
            field: 'contact',
            headerName: 'CONTACT',
            flex: 1,
            minWidth: 180,
            maxWidth: 180,
        },
        {
            field: 'agencyName',
            headerName: 'AGENCY',
            flex: 1,
            width: 180,
            minWidth: 180,
        },
        {
            field: 'register_in',
            headerName: 'SOURCE',
            flex: 1,
            width: 200,
            minWidth: 200,
            maxWidth: 200,
            valueGetter: (params: any) => params?.row?.registerIn?.name || '-',
            renderCell: (params: any) => {
                const company = params?.row?.registerIn?.name;

                const getStyles = (companyName: string | undefined) => {
                    switch (companyName) {
                        case 'Brokers Alliance':
                            return {
                                backgroundColor: 'rgba(0, 174, 255, 0.1)',
                                border: '1px solid #00aeff',
                                color: '#00aeff'
                            };
                        case 'Retirement Brain':
                            return {
                                backgroundColor: 'rgba(255, 179, 0, 0.1)',
                                border: '1px solid #ffb300',
                                color: '#ffb300'
                            };
                        case 'Acrylic Financial':
                            return {
                                backgroundColor: 'rgb(205, 141, 141,  0.1)',
                                border: '1px solid #cd8d8d',
                                color: '#ffdfdf'
                            };
                        case 'Brooklight':
                            return {
                                backgroundColor: 'rgb(126, 244, 255, 0.1)',
                                border: '1px solid rgb(126 244 255)',
                                color: 'rgb(126 244 255)'
                            };
                        case 'Life Brain':
                            return {
                                backgroundColor: 'rgb(111, 207, 100, 0.1)',
                                border: '1px solid rgb(111 207 100)',
                                color: 'rgb(111 207 100)'
                            };
                        default:
                            return {
                                backgroundColor: 'transparent',
                                border: '1px solid #ccc',
                                color: 'white'
                            };
                    }
                };

                const styles = getStyles(company);

                return (
                    <div
                        style={{
                            padding: '4px 12px',
                            fontSize: '12px',
                            fontWeight: 500,
                            borderRadius: '15px',
                            display: 'inline-block',
                            textAlign: 'center',
                            ...styles
                        }}
                    >
                        {company || '-'}
                    </div>
                );

            }
        },
        {
            field: 'lastLoginAt',
            headerName: 'LAST LOGIN',
            flex: 1,
            width: 170,
            minWidth: 170,
            valueFormatter: (params: any) => params?.value ? moment(params.value).format('MM/DD/YYYY') : '',
        },
        {
            field: 'group',
            headerName: 'GROUP',
            flex: 1,
            width: 170,
            minWidth: 170,
            renderCell: (params: any) => {
                const groupId = params.row?.group?.id
                const userId = Number(params.row?.userId)
                const isAdmin = params.row.admin;
                return (
                    <>
                        {!isAdmin && (
                            <div style={{ width: "100%" }} onClick={(e) => e.stopPropagation()}>
                                <GlobalSelect
                                    className={`${styles.userGroupAppStatusDropdown}`}
                                    size='small'
                                    fullWidth
                                    value={groupId || ""}
                                    options={
                                        groupOptionsList?.groups?.length ? groupOptionsList?.groups?.map((status: any) => ({ label: status.groupName, value: status.groupId })) : []
                                    }
                                    onChange={(e) => {
                                        const selectedGroupId = Number(e.target.value);
                                        handleGroupChange(userId, selectedGroupId);

                                    }}
                                />
                            </div>
                        )}
                    </>
                )
            }
            // valueFormatter: (params: any) => params?.value?.name,
        },
        {
            field: 'status_id',
            headerName: 'STATUS',
            flex: 1,
            width: 120,
            minWidth: 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: any) => {
                const status = params.row?.userStatus?.status;
                const isAdmin = params.row?.admin

                if (isAdmin == false && status === 'UnderReview') {
                    return (
                        <Grid
                            sx={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                border: "1px solid white",
                                borderRadius: '15px',
                                fontSize: '11px',
                                fontWeight: '500',
                                padding: "5px 8px"
                            }}
                        >
                            Under Review
                        </Grid>
                    );
                }

                const isChecked = status === 'Active';

                return (
                    <>
                        {isAdmin == false &&
                            <FormControlLabel
                                className={styles.iosSwitch}
                                sx={{ margin: '0px !important' }}
                                label=""
                                control={
                                    <IOSSwitch
                                        sx={{ m: 1 }}
                                        checked={isChecked}
                                        onClick={(event: any) => {
                                            event.stopPropagation(); // Prevent row click
                                        }}
                                        onChange={(event: any) => {
                                            handleUserStatus(params.row, isChecked ? 'InActive' : 'Active')
                                        }}
                                    />
                                }
                            />
                        }
                    </>
                );
            }
        },
        {
            field: 'action',
            headerName: '',
            minWidth: 50,
            maxWidth: 50,
            align: "right",
            headerAlign: "right",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const isAdmin = params.row?.admin
                const row = params?.row
                return (
                    <>
                        {isAdmin == false &&
                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenMenu(e, row)
                                    setFlagDeleteMemberDialog(true)
                                    handleClose();
                                }}
                            >
                                <Tooltip
                                    title="Delete"
                                    arrow
                                    placement="bottom"
                                    componentsProps={{
                                        tooltip: { className: globalStyles.globalTooltipStyle },
                                        arrow: { className: globalStyles.globalTooltipArrowStyle },
                                    }}
                                >
                                    <img src={deleteIcon} alt="" style={{ width: '30px', height: '30px' }} />
                                </Tooltip>
                            </IconButton>
                        }
                    </>
                )
            }

        }
    ];


    const handleGroupChange = async (userId: number, groupId: number) => {
        if (!userId || !groupId) return;
        const payload = { userId, groupId };

        setFlagLoader(true)
        const response = await agent.updateUserStatusApiGroup.put(payload)
        if (response?.status) {
            console.log("response of updateUserStatusApi", response);
            await initializeAuth()
            const successMessage = response?.message ? response?.message : "User details updated successfully!"
            showSnackbar(successMessage, "success");
            setFlagLoader(false)
        }
        else {
            console.log("response false of updateUserStatusApi", response);
            const successMessage = response?.error?.message ? response?.error?.message : "Something Went Wrong!"
            showSnackbar(successMessage, "error");
            setFlagLoader(false)
        }
    }

    const initializeAuth = async () => {
        setFlagLoader(true);
        const payload = {
            filterModel: JSON.stringify(filterModel),
            paginationModel: JSON.stringify({
                page: paginationModel.page,
                pageSize: paginationModel.pageSize,
            }),
            sortModel: JSON.stringify(sortModel),
        };

        const response = await agent.getUsersListDetailsApiV2.get(payload);
        if (response?.status && response?.data) {
            setMemberUserListDetails(response.data);
            setRowCount(response.data?.filteredUserCount || 0);
        } else {
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
        setFlagLoader(false);
    };

    const fetchUserGroupData = async () => {
        setFlagLoader(true)
        const response = await agent.getGroupDetailsByGroupApi.get()
        if (response?.status) {
            console.log("response of getUserGroupsApi", response);
            const responseData = response?.data
            setGroupOptionList(responseData)
            setFlagLoader(false)
        }
        else {
            const errorMessage = response?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
        }
    }

    useEffect(() => {
        fetchUserGroupData()
    }, [])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const items = filterModel?.items || [];

            const hasFilterWithValue = items.some((item: any) => "value" in item && item.value !== undefined && item.value !== null);
            const shouldTriggerApi = items.length === 0 || hasFilterWithValue;
            if (shouldTriggerApi) {
                initializeAuth();
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [paginationModel, sortModel, filterModel]);


    const handleUserStatus = async (row: any, newStatus: 'Active' | 'InActive') => {
        const payload: UpdateUserStatusByPayloadModel = {
            userId: row.userId ?? "",
            firstName: row.firstName ?? "",
            lastName: row.lastName ?? "",
            contact: row.contact ?? "",
            agencyName: row.agencyName ?? "",
            city: row.city ?? "",
            zipcode: row.zipcode ?? "",
            stateID: row.stateID ?? "",
            addressLine1: row.addressLine1 ?? "",
            addressLine2: row.addressLine2 ?? "",
            affiliated_Brooklight: row.affiliated_Brooklight ?? "",
            affiliated_BA: row.affiliated_BA ?? "",
            profileImage: row.profileImage ?? null,
            status: newStatus,
        };

        try {
            const response = await agent.updateUserStatusApi.put(payload);
            if (response?.status) {
                await initializeAuth();
                const successMessage = response?.message ? response?.message : "Status updated successfully!"
                showSnackbar(successMessage, "success");
            }
            else {
                const error = response?.data?.error?.message || 'Something Went Wrong!'
                showSnackbar(error, "error");
            }
        }
        catch (error) {
            showSnackbar("Error occurred while updating status", "error");
        }
    };

    const handleOpenMenu = (event: any, row: any) => {
        setAnchorEl(event.currentTarget);
        setStoredExistingMemberDetails(row)
    };

    const handleClose = () => {
        setAnchorEl(null)
    };

    const handleDeleteMember = async () => {
        if (storedExistingMemberDetails?.userId) {
            const payload = {
                userId: storedExistingMemberDetails?.userId ?? 0,
                status: "Deleted",
            };

            setFlagLoader(true)
            const response = await agent.updateUserStatusApi.put(payload)
            if (response?.status) {
                console.log("response of updateUserStatusApi", response);
                await initializeAuth()
                const successMessage = response?.message ? response?.message : "User Deleted Successfully!"
                showSnackbar(successMessage, "success");
                setFlagLoader(false)
                setFlagDeleteMemberDialog(false)
            }
            else {
                console.log("response false of updateUserStatusApi", response);
                const successMessage = response?.message ? response?.message : "Something Went Wrong!"
                showSnackbar(successMessage, "error");
                setFlagLoader(false)
                setFlagDeleteMemberDialog(false)
            }
        }
    }

    const handleCellClick = (params: any) => {
        const userId = params?.row?.userId;
        const isAdmin = params?.row?.admin;

        if (userId && !isAdmin) {
            navigate(`/member/viewUsers?userId=${userId}&tab=1`);
        }
    };

    const CustomToolbar = () => (
        <GridToolbarContainer
            sx={{
                color: '#fff',
                marginBottom: '10px',
                '& .MuiButtonBase-root': {
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '14px',
                    textTransform: 'uppercase',
                },
            }}
        >
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarExport />
        </GridToolbarContainer>
    );

    const NoDataOverlay = () => (
        <Box
            sx={{
                textAlign: 'center',
                width: '100%',
                marginTop: '40px',
                color: '#ccc',
            }}
        >
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                No Data Found
            </Typography>
        </Box>
    );


    return (
        <>
            {flagDeleteMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagDeleteMemberDialog}
                    maxWidth="sm"
                    dialogHead={'Delete Confirmation'}
                    onClose={() => { setFlagDeleteMemberDialog(false) }}
                    view={
                        <GlobalWarningDialog
                            popupDescription={`Are you sure you want delete ${storedExistingMemberDetails?.fullName}?`}
                            primaryButtonText={"Delete"}
                            secondaryButtonText={"Cancel"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleDeleteMember}
                            handleClose={() => { setFlagDeleteMemberDialog(false) }}
                        />
                    }
                />
            }

            <Grid container sx={{ position: 'relative', justifyContent: isBelow900 ? "center" : "" }}>
                <Grid className={styles.totalUserItem}>
                    <Grid container sx={{ alignItems: 'center', gap: '10px' }}>
                        <Grid>
                            <Grid container>
                                <Typography component={'span'} className={styles.totalUserText}>
                                    Total Users:&nbsp;
                                </Typography>
                                <Typography component={'span'} className={styles.totalValue}>
                                    {memberUserListDetails?.totalUserCount ? memberUserListDetails?.totalUserCount : ""}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid>|</Grid>

                        <Grid>
                            <Grid container>
                                <Typography component={'span'} className={styles.totalActiveText}>
                                    Active:&nbsp;
                                </Typography>
                                <Typography component={'span'} className={styles.totalValue}>
                                    {memberUserListDetails?.activeUserCount ? memberUserListDetails?.activeUserCount : ""}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid>
                            <Grid container>
                                <Typography component={'span'} className={styles.totalInactiveText}>
                                    Inactive:&nbsp;
                                </Typography>
                                <Typography component={'span'} className={styles.totalValue}>
                                    {memberUserListDetails?.inActiveUserCount ? memberUserListDetails?.inActiveUserCount : ""}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12 }} className={styles.userTableItem} sx={{ margin: "20px 0px 0px", height: "calc(100vh - 235px)" }}>
                    <DataGrid
                        rows={memberUserListDetails?.users ?? []}
                        columns={columns}
                        getRowId={(row) => row.userId}
                        rowCount={rowCount}
                        className={`${globalStyles.globalDatagridStyles} ${styles.userTableStyles}`}
                        checkboxSelection={false}
                        disableRowSelectionOnClick
                        rowHeight={50}
                        columnHeaderHeight={50}
                        onCellClick={handleCellClick}
                        pagination
                        paginationMode="server"
                        sortingMode="server"
                        filterMode="server"
                        onPaginationModelChange={(newModel) => { setPaginationModel(newModel); }}
                        onSortModelChange={(newSort) => { setSortModel(newSort); }}
                        onFilterModelChange={(newFilter) => { setFilterModel(newFilter); }}
                        // onFilterModelChange={(newFilter) => {
                        //     setPaginationModel((prev) => ({
                        //         ...prev,
                        //         page: 0, 
                        //     }));
                        //     setFilterModel({ ...newFilter }); 
                        // }}
                        paginationModel={paginationModel}
                        pageSizeOptions={[10, 20, 30, { label: '100', value: 100 }]}
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 20, page: 0 }
                            }
                        }}
                        slots={{ toolbar: CustomToolbar, noRowsOverlay: NoDataOverlay }}
                        sx={{
                            '& .clickable-row': { cursor: 'pointer' },
                            '& .non-clickable-row': { cursor: 'default' },
                            '& .MuiToolbar-root': { minHeight: '45px !important' },
                            '& .MuiDataGrid-row:hover': {
                                backgroundColor: '#939ba354',
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default Users